import React from "react";

import { Group } from "@visx/group";

import { ScatterPlot } from "../components/ScatterPlot";

import type { XYChartScatterPlotProps } from "./types";

const XYChartLines = ({
  data,
  getLeftPoint,
  getRightPoint,
  coloursScale,
  hoveredLegendItem,
  leftScale,
  rightScale,
  ...commonChartProps
}: XYChartScatterPlotProps) => {
  return (
    <Group>
      {data?.map(({ data: scatterPlotData, axis, label }, index) => {
        const colour = coloursScale(label);

        return (
          <ScatterPlot
            key={`scatter-plot-chart-${index}`}
            {...commonChartProps}
            data={scatterPlotData}
            getSidePoint={axis === "left" ? getLeftPoint : getRightPoint}
            colour={
              hoveredLegendItem !== undefined && hoveredLegendItem !== label
                ? `${colour}25`
                : colour
            }
            sideScale={axis === "left" ? leftScale : rightScale}
          />
        );
      }, [])}
    </Group>
  );
};

export default XYChartLines;
